export default "__VITE_ASSET__ff9c428e__"